import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { DATE_FORMAT } from '../../../constants'
class CreditUsageBody extends Component {
    render() {
        if (this.props.creditUsageData.creditviewList.length > 0) {
            return (
                this.props.creditUsageData.creditviewList.map((p, index) => {
                    // if (p.deliveryDate != null) {
                    return (
                        <Row noGutters className="bg-light border-bottom p-3 p-sm-0 mb-3 mb-sm-0" key={index}>
                            <Col sm="4" className="custom-table-col p-sm-4 mb-2 mb-sm-0"  title={p.corporateName}><span className="d-sm-none font-family-bold">Subsidiary/Division Name: </span>{p.corporateName}</Col>
                            <Col sm="3" className="custom-table-col p-sm-3 mb-2 mb-sm-0"  title={p.requestedByName}><span className="d-sm-none font-family-bold">Requested By : </span>{p.requestedByName}</Col>
                            <Col sm="4" className="custom-table-col p-sm-3 mb-2 mb-sm-0"  title={p.counterpartyName}><span className="d-sm-none font-family-bold">Company Name : </span>{p.counterpartyName}</Col>
                            <Col sm="5" className="custom-table-col p-sm-3 mb-2 mb-sm-0"  title={p.productName}><span className="d-sm-none font-family-bold">Report Type : </span>{p.productName}</Col>
                            <Col sm="1" className="custom-table-col p-sm-3 mb-2 mb-sm-0"  title={p.rubixScore}><span className="d-sm-none font-family-bold">Rubix Score : </span><i className='d-sm-none font-family-bold'></i>{p.rubixScore}</Col>
                            <Col sm="1" className="custom-table-col p-sm-3 mb-2 mb-sm-0"  title={p.rubixRiskGrade}><span className="d-sm-none font-family-bold">Rubix Risk Grade : </span><i className='d-sm-none font-family-bold'></i>{p.rubixRiskGrade}</Col>
                            <Col sm="2" className="custom-table-col p-sm-3 mb-2 mb-sm-0 text-capitalize" title={p.state}><span className="d-sm-none font-family-bold">State : </span>{p.state}</Col>
                            <Col sm="2" className="custom-table-col p-sm-3 mb-2 mb-sm-0 text-capitalize" title={p.country}><span className="d-sm-none font-family-bold">Country : </span>{p.country}</Col>
                            {(p.deliveryDate) ? <Col sm="2" className="custom-table-col p-sm-3 mb-2 mb-sm-0"  title={moment(p.deliveryDate).format(DATE_FORMAT)}><span className="d-sm-none font-family-bold">Delivery Date : </span>{moment(p.deliveryDate).format(DATE_FORMAT)}</Col> : <Col sm="2" className="custom-table-col p-sm-3 mb-2 mb-sm-0" ></Col>}
                        </Row>
                    )
                })
            )
        }
        else {
            return (
                <Row noGutters className="bg-light text-center border-bottom p-3 p-sm-0 mb-3 mb-sm-0" >
                    No Records are present .
                </Row>
            );
        }
    }
}
export default CreditUsageBody;
